// src/pages/user/Support.js
// Page support/aide - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { APP_CONFIG } from '../../constants/config';

const Support = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleWhatsApp = () => {
    const phone = APP_CONFIG.SUPPORT_WHATSAPP.replace(/\D/g, '');
    window.open(`https://wa.me/${phone}`, '_blank');
  };

  const handleEmail = () => {
    window.location.href = `mailto:${APP_CONFIG.SUPPORT_EMAIL}`;
  };

  const faqItems = [
    {
      q: 'Comment réserver un logement ?',
      a: 'Ouvrez une annonce, cliquez sur "Réserver", remplissez le formulaire avec votre nom et WhatsApp. Notre équipe vous met en contact avec le propriétaire.',
    },
    {
      q: 'Le paiement se fait-il sur l\'app ?',
      a: 'Non. Aucun paiement ne passe par Fynho. Vous payez directement au propriétaire (cash ou mobile money) une fois la réservation confirmée.',
    },
    {
      q: 'Dois-je créer un compte ?',
      a: 'Non, la consultation et la réservation sont possibles sans compte. Un compte permet de sauvegarder vos favoris.',
    },
    {
      q: 'Comment publier une annonce ?',
      a: 'Les annonces sont gérées par notre équipe. Contactez-nous via WhatsApp pour proposer votre bien.',
    },
  ];

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    contactButtons: {
      display: 'flex',
      gap: '10px',
      padding: '16px',
    },
    contactButton: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '6px',
      padding: '16px',
      borderRadius: '12px',
      cursor: 'pointer',
      border: 'none',
      fontSize: '13px',
      fontWeight: '600',
    },
    whatsappBtn: {
      backgroundColor: 'rgba(72, 187, 120, 0.1)',
      border: '1px solid rgba(72, 187, 120, 0.3)',
      color: '#48BB78',
    },
    emailBtn: {
      backgroundColor: 'rgba(66, 153, 225, 0.1)',
      border: '1px solid rgba(66, 153, 225, 0.3)',
      color: '#4299E1',
    },
    contactIcon: { fontSize: '24px' },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#FFFFFF',
      padding: '16px 16px 8px',
    },
    faqItem: {
      margin: '0 16px 12px',
      padding: '16px',
      backgroundColor: '#162033',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.05)',
    },
    faqQuestion: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#FFD700',
      marginBottom: '8px',
    },
    faqAnswer: {
      fontSize: '13px',
      color: '#A0AEC0',
      lineHeight: '1.5',
    },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Aide & Support | Fynho</title>
        <meta name="description" content="Besoin d'aide ? Contactez le support Fynho par WhatsApp ou email." />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>←</button>
        <div style={styles.title}>❓ {t('common.support')}</div>
      </div>

      <div style={styles.contactButtons}>
        <button
          style={{ ...styles.contactButton, ...styles.whatsappBtn }}
          onClick={handleWhatsApp}
        >
          <span style={styles.contactIcon}>💬</span>
          WhatsApp
        </button>
        <button
          style={{ ...styles.contactButton, ...styles.emailBtn }}
          onClick={handleEmail}
        >
          <span style={styles.contactIcon}>✉️</span>
          Email
        </button>
      </div>

      <div style={styles.sectionTitle}>Questions fréquentes</div>

      {faqItems.map((item, index) => (
        <div key={index} style={styles.faqItem}>
          <div style={styles.faqQuestion}>{item.q}</div>
          <div style={styles.faqAnswer}>{item.a}</div>
        </div>
      ))}
    </div>
  );
};

export default Support;